import { useLang } from 'models/langContext';
import { useState } from 'react';

export const useTranslations = () => {
  const { translations, showKeyTranslations } = useLang();

  const [loadingT, setLoadingT] = useState(!translations || translations.length < 0);

  const t = (key: string) => {
    if (!translations || translations.length === 0) {
      const test = key.split('.');
      return test[test.length - 1];
    }
    const translation = translations.find((trans: { key: string }) => trans.key === key);
    if (translation) {
      if (showKeyTranslations) {
        return translation.key;
      }
      return translation.value;
    }
    return key;
  };
  return { t, loadingT, setLoadingT };
};
